import { isStaleChunkError } from "./is-stale-chunk-error";

/** A lazy route keeps its failed import for the page's lifetime, so only a fresh document retries a stale chunk. */
export function retryAfterError(
	error: unknown,
	reset: () => void,
	reload: () => void = () => window.location.reload(),
): void {
	if (isStaleChunkError(error)) {
		reload();
		return;
	}
	reset();
}
